"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOverlappingCopperResultToReview = convertOverlappingCopperResultToReview;
exports.sortOverlappingCopperProblems = sortOverlappingCopperProblems;
const shared_1 = require("@buildwithflux/shared");
const pcb_1 = require("../../pcb");
const reviews_1 = require("../../reviews");
const common_1 = require("./common");
function convertOverlappingCopperResultToReview(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const [designator1 = null, designator2 = null] = problem.affectedItems.map((a) => {
            const node = nodes[a.uid];
            if (node?.type === pcb_1.PcbNodeTypes.pad) {
                const componentUid = a.uid.split("_")[0] ?? "";
                const component = (0, common_1.getLabelForPcbNode)(nodes[componentUid]);
                const padBakedNode = node;
                const terminalId = padBakedNode.terminalId;
                const nodeLabel = (0, common_1.getLabelForPcbNode)(node);
                let pinInfo;
                if (nodeLabel && nodeLabel.trim() !== "") {
                    pinInfo = nodeLabel;
                }
                else if (terminalId && terminalId.trim() !== "") {
                    pinInfo = terminalId;
                }
                else if (a.itemLabel && a.itemLabel.trim() !== "") {
                    pinInfo = a.itemLabel;
                }
                else {
                    pinInfo = a.uid.substring(0, 8);
                }
                const designator = (0, common_1.sanitizeDesignator)(`${component}:${pinInfo}`);
                designatorUidMap[designator] = a.uid;
                return designator;
            }
            else {
                const designator = (0, common_1.sanitizeDesignator)(a.itemLabel ?? (0, common_1.getLabelForPcbNode)(node));
                designatorUidMap[designator] = a.uid;
                return designator;
            }
        });
        const [net1 = null, net2 = null] = problem.affectedItems.map((a) => {
            const net = (0, common_1.sanitizeDesignator)((0, common_1.getNetNameForNode)(a.uid, nodes));
            const netUid = (0, common_1.getNetUidForNode)(a.uid, nodes);
            if (net && netUid) {
                designatorUidMap[net] = netUid;
            }
            return net;
        });
        const [layer1 = null, layer2 = null] = problem.affectedItems.map((a) => {
            return (0, common_1.getLayerForNode)(a.uid, nodes);
        });
        return {
            name: designator1,
            designator1,
            net1,
            layer1,
            designator2,
            net2,
            layer2,
            status: net1 && net2 && net1 === net2 ? reviews_1.ReviewStatus.WARNING : reviews_1.ReviewStatus.ERROR,
            designatorUidMap,
        };
    };
}
function sortOverlappingCopperProblems(problems, nodes) {
    const converter = convertOverlappingCopperResultToReview(nodes);
    const sortedProblems = [...problems].sort((a, b) => {
        const itemA = converter(a);
        const itemB = converter(b);
        const statusA = itemA.status ?? reviews_1.ReviewStatus.ERROR;
        const statusB = itemB.status ?? reviews_1.ReviewStatus.ERROR;
        const severityDiff = (reviews_1.priorityMap[statusB] ?? 0) - (reviews_1.priorityMap[statusA] ?? 0);
        if (severityDiff !== 0) {
            return severityDiff;
        }
        const net1A = itemA.net1 ?? "zzz_none";
        const net1B = itemB.net1 ?? "zzz_none";
        const net1Diff = (0, shared_1.naturalSortByProperty)("net1")({ net1: net1A }, { net1: net1B });
        if (net1Diff !== 0) {
            return net1Diff;
        }
        const designator1A = itemA.designator1 ?? "zzz_none";
        const designator1B = itemB.designator1 ?? "zzz_none";
        const designator1Diff = (0, shared_1.naturalSortByProperty)("designator1")({ designator1: designator1A }, { designator1: designator1B });
        if (designator1Diff !== 0) {
            return designator1Diff;
        }
        const net2A = itemA.net2 ?? "zzz_none";
        const net2B = itemB.net2 ?? "zzz_none";
        const net2Diff = (0, shared_1.naturalSortByProperty)("net2")({ net2: net2A }, { net2: net2B });
        if (net2Diff !== 0) {
            return net2Diff;
        }
        const designator2A = itemA.designator2 ?? "zzz_none";
        const designator2B = itemB.designator2 ?? "zzz_none";
        return (0, shared_1.naturalSortByProperty)("designator2")({ designator2: designator2A }, { designator2: designator2B });
    });
    return { sortedProblems, converter };
}
//# sourceMappingURL=overlappingCopper.js.map